import React, { CSSProperties } from 'react'
import './preloader.scss'

interface Props {
  size?: 'xs' | 'sm' | 'md' | 'lg'
  className?: string
  style?: CSSProperties
}

export const Preloader = ({ size = 'md', className, style }: Props) => (
  <svg
    className={`preloader preloader__${size} ${className}`}
    fill='currentColor'
    data-testid='preloader'
    xmlns='http://www.w3.org/2000/svg'
    x='0px'
    y='0px'
    viewBox='0 0 34 32'
    style={style}
  >
    <g transform='matrix(1.06288 0 0 1.066667 2.177246 2.133329)'>
      <path
        id='eCEoqcS3Otn3'
        d='M8.97,6.18c0-2.22,1.81-4.03,4.03-4.03s4.03,1.81,4.03,4.03v.07h2.14v-.07C19.17,2.77,16.4,0,12.99,0s-6.18,2.77-6.18,6.18v.07h2.14v-.07h.02Z'
        fill='#f16545'
      />
      <path
        id='eCEoqcS3Otn4'
        d='M17.03,19.82c0,2.22-1.81,4.03-4.03,4.03s-4.03-1.81-4.03-4.03v-.07h-2.14v.07C6.83,23.23,9.6,26,13.01,26s6.18-2.77,6.18-6.18v-.07h-2.14v.07h-.02Z'
        fill='#f16545'
      />
      <path
        d='M19.82,6.82h-13.64C2.77,6.82,0,9.59,0,13s2.77,6.18,6.18,6.18h13.65c3.41,0,6.18-2.77,6.18-6.18s-2.77-6.18-6.18-6.18h-.01Zm0,10.21h-5.75v-2.39h-2.14v2.39h-5.75c-2.22,0-4.03-1.81-4.03-4.03s1.81-4.03,4.03-4.03h5.75v2.39h2.14v-2.39h5.75c2.22,0,4.03,1.81,4.03,4.03s-1.81,4.03-4.03,4.03Z'
        fill='#395f96'
      />
      <polygon
        points='17.03,9.54 17.03,11.93 14.64,11.93 14.36,11.93 14.07,11.93 11.93,11.93 11.64,11.93 11.36,11.93 8.97,11.93 8.97,9.54 6.82,9.54 6.82,11.93 6.82,14.07 6.82,16.46 8.97,16.46 8.97,14.07 11.36,14.07 11.64,14.07 11.93,14.07 14.07,14.07 14.36,14.07 14.64,14.07 17.03,14.07 17.03,16.46 19.18,16.46 19.18,14.07 19.18,11.93 19.18,9.54 17.03,9.54'
        fill='#fcb912'
      />
    </g>
  </svg>
)
